module.exports = __webpack_public_path__ + "img/Visa.61cea153.svg";